export default __webpack_public_path__ + "static/media/you-areAmazing.e801c6f3.webp";